import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import LivingClassAdmin_001 from './img/LivingClassAdmin_001.png'
import LivingClassAdmin_002 from './img/LivingClassAdmin_002.png'

export default class LivingClassAdmin extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">管理员使用在线课堂</div>
        <div className="main-window-content">管理员，进入在线课堂界面，点击教程，即可查看具体教程，并可添加学习，同时具备管理功能</div>
        <img src={LivingClassAdmin_001} className="main-window-img"></img>
        <img src={LivingClassAdmin_002} className="main-window-img"></img>
      </div>
    )
  }
}
